// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/memo_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Attachment } from "./attachment_service_pb";
import { file_api_v1_attachment_service } from "./attachment_service_pb";
import type { State } from "./common_pb";
import { file_api_v1_common } from "./common_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/memo_service.proto.
 */
export const file_api_v1_memo_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_v1_attachment_service, file_api_v1_common, file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message journal.api.v1.Reaction
 */
export type Reaction = Message<"journal.api.v1.Reaction"> & {
  /**
   * The resource name of the reaction.
   * Format: memos/{memo}/reactions/{reaction}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The resource name of the creator.
   * Format: users/{user}
   *
   * @generated from field: string creator = 2;
   */
  creator: string;

  /**
   * The resource name of the content.
   * For memo reactions, this should be the memo's resource name.
   * Format: memos/{memo}
   *
   * @generated from field: string content_id = 3;
   */
  contentId: string;

  /**
   * Required. The type of reaction (e.g., "👍", "❤️", "😄").
   *
   * @generated from field: string reaction_type = 4;
   */
  reactionType: string;

  /**
   * Output only. The creation timestamp.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;
};

/**
 * Describes the message journal.api.v1.Reaction.
 * Use `create(ReactionSchema)` to create a new message.
 */
export const ReactionSchema: GenMessage<Reaction> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 0);

/**
 * MemoPriceSnapshot represents a price snapshot at the time a memo was created/updated
 *
 * @generated from message journal.api.v1.MemoPriceSnapshot
 */
export type MemoPriceSnapshot = Message<"journal.api.v1.MemoPriceSnapshot"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string memo_id = 2;
   */
  memoId: string;

  /**
   * @generated from field: string ticker_symbol = 3;
   */
  tickerSymbol: string;

  /**
   * Price at the time memo was created/updated
   *
   * @generated from field: float price = 4;
   */
  price: number;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * Unix timestamp when the snapshot was taken
   *
   * @generated from field: int64 timestamp = 6;
   */
  timestamp: bigint;

  /**
   * @generated from field: optional float change = 7;
   */
  change?: number;

  /**
   * @generated from field: optional float change_percent = 8;
   */
  changePercent?: number;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt: bigint;

  /**
   * Current price comparison (for memo detail view)
   *
   * @generated from field: optional float current_price = 10;
   */
  currentPrice?: number;

  /**
   * @generated from field: optional float current_change = 11;
   */
  currentChange?: number;

  /**
   * @generated from field: optional float current_change_percent = 12;
   */
  currentChangePercent?: number;
};

/**
 * Describes the message journal.api.v1.MemoPriceSnapshot.
 * Use `create(MemoPriceSnapshotSchema)` to create a new message.
 */
export const MemoPriceSnapshotSchema: GenMessage<MemoPriceSnapshot> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 1);

/**
 * @generated from message journal.api.v1.Memo
 */
export type Memo = Message<"journal.api.v1.Memo"> & {
  /**
   * The resource name of the memo.
   * Format: memos/{memo}, memo is the user defined id or uuid.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The state of the memo.
   *
   * @generated from field: journal.api.v1.State state = 2;
   */
  state: State;

  /**
   * The name of the creator.
   * Format: users/{user}
   *
   * @generated from field: string creator = 3;
   */
  creator: string;

  /**
   * Output only. The creation timestamp.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * Output only. The last update timestamp.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: Timestamp;

  /**
   * The display timestamp of the memo.
   *
   * @generated from field: google.protobuf.Timestamp display_time = 6;
   */
  displayTime?: Timestamp;

  /**
   * Required. The content of the memo in Markdown format.
   *
   * @generated from field: string content = 7;
   */
  content: string;

  /**
   * The content type of the memo (e.g., "markdown", "lexical").
   * Default is "markdown" if not specified.
   *
   * @generated from field: string content_type = 8;
   */
  contentType: string;

  /**
   * Output only. The tags extracted from the content.
   *
   * @generated from field: repeated string tags = 10;
   */
  tags: string[];

  /**
   * Whether the memo is pinned.
   *
   * @generated from field: bool pinned = 11;
   */
  pinned: boolean;

  /**
   * Optional. The attachments of the memo.
   *
   * @generated from field: repeated journal.api.v1.Attachment attachments = 12;
   */
  attachments: Attachment[];

  /**
   * Optional. The relations of the memo.
   *
   * @generated from field: repeated journal.api.v1.MemoRelation relations = 13;
   */
  relations: MemoRelation[];

  /**
   * Output only. The reactions to the memo.
   *
   * @generated from field: repeated journal.api.v1.Reaction reactions = 14;
   */
  reactions: Reaction[];

  /**
   * Output only. The computed properties of the memo.
   *
   * @generated from field: journal.api.v1.Memo.Property property = 15;
   */
  property?: Memo_Property;

  /**
   * Output only. The name of the parent memo.
   * Format: memos/{memo}
   *
   * @generated from field: optional string parent = 16;
   */
  parent?: string;

  /**
   * Output only. The snippet of the memo content. Plain text only.
   *
   * @generated from field: string snippet = 17;
   */
  snippet: string;

  /**
   * Optional. The location of the memo.
   *
   * @generated from field: optional journal.api.v1.Location location = 18;
   */
  location?: Location;

  /**
   * Output only. Price snapshots for stock symbols mentioned in this memo.
   *
   * @generated from field: repeated journal.api.v1.MemoPriceSnapshot price_snapshots = 30;
   */
  priceSnapshots: MemoPriceSnapshot[];

  /**
   * Output only. AI analysis for this memo.
   * Contains ui_tree and analyzed_at fields if include_ai_analysis is set in GetMemoRequest.
   *
   * @generated from field: google.protobuf.Struct ai_analysis = 31;
   */
  aiAnalysis?: JsonObject;
};

/**
 * Describes the message journal.api.v1.Memo.
 * Use `create(MemoSchema)` to create a new message.
 */
export const MemoSchema: GenMessage<Memo> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 2);

/**
 * Computed properties of a memo.
 *
 * @generated from message journal.api.v1.Memo.Property
 */
export type Memo_Property = Message<"journal.api.v1.Memo.Property"> & {
  /**
   * @generated from field: bool has_link = 1;
   */
  hasLink: boolean;

  /**
   * @generated from field: bool has_task_list = 2;
   */
  hasTaskList: boolean;

  /**
   * @generated from field: bool has_code = 3;
   */
  hasCode: boolean;

  /**
   * @generated from field: bool has_incomplete_tasks = 4;
   */
  hasIncompleteTasks: boolean;
};

/**
 * Describes the message journal.api.v1.Memo.Property.
 * Use `create(Memo_PropertySchema)` to create a new message.
 */
export const Memo_PropertySchema: GenMessage<Memo_Property> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 2, 0);

/**
 * @generated from message journal.api.v1.Location
 */
export type Location = Message<"journal.api.v1.Location"> & {
  /**
   * A placeholder text for the location.
   *
   * @generated from field: string placeholder = 1;
   */
  placeholder: string;

  /**
   * The latitude of the location.
   *
   * @generated from field: double latitude = 2;
   */
  latitude: number;

  /**
   * The longitude of the location.
   *
   * @generated from field: double longitude = 3;
   */
  longitude: number;
};

/**
 * Describes the message journal.api.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 3);

/**
 * @generated from message journal.api.v1.CreateMemoRequest
 */
export type CreateMemoRequest = Message<"journal.api.v1.CreateMemoRequest"> & {
  /**
   * Required. The memo to create.
   *
   * @generated from field: journal.api.v1.Memo memo = 1;
   */
  memo?: Memo;

  /**
   * Optional. The memo ID to use for this memo.
   * If empty, a unique ID will be generated.
   *
   * @generated from field: string memo_id = 2;
   */
  memoId: string;
};

/**
 * Describes the message journal.api.v1.CreateMemoRequest.
 * Use `create(CreateMemoRequestSchema)` to create a new message.
 */
export const CreateMemoRequestSchema: GenMessage<CreateMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 4);

/**
 * @generated from message journal.api.v1.ListMemosRequest
 */
export type ListMemosRequest = Message<"journal.api.v1.ListMemosRequest"> & {
  /**
   * Optional. The maximum number of memos to return.
   * The service may return fewer than this value.
   * If unspecified, at most 50 memos will be returned.
   * The maximum value is 1000; values above 1000 will be coerced to 1000.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `ListMemos` call.
   * Provide this to retrieve the subsequent page.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * Optional. The state of the memos to list.
   * Default to `NORMAL`. Set to `ARCHIVED` to list archived memos.
   *
   * @generated from field: journal.api.v1.State state = 3;
   */
  state: State;

  /**
   * Optional. The order to sort results by.
   * Default to "display_time desc".
   * Supports comma-separated list of fields following AIP-132.
   * Example: "pinned desc, display_time desc" or "create_time asc"
   * Supported fields: pinned, display_time, create_time, update_time, name
   *
   * @generated from field: string order_by = 4;
   */
  orderBy: string;

  /**
   * Optional. Filter to apply to the list results.
   * Filter is a CEL expression to filter memos.
   * Refer to `Shortcut.filter`.
   *
   * @generated from field: string filter = 5;
   */
  filter: string;

  /**
   * Optional. If true, show deleted memos in the response.
   *
   * @generated from field: bool show_deleted = 6;
   */
  showDeleted: boolean;

  /**
   * Optional. Whether to include AI analysis preview in the response.
   * Default is false.
   * When enabled, ai_analysis field will contain ui_tree preview data.
   *
   * @generated from field: bool include_ai_analysis = 7;
   */
  includeAiAnalysis: boolean;
};

/**
 * Describes the message journal.api.v1.ListMemosRequest.
 * Use `create(ListMemosRequestSchema)` to create a new message.
 */
export const ListMemosRequestSchema: GenMessage<ListMemosRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 5);

/**
 * @generated from message journal.api.v1.ListMemosResponse
 */
export type ListMemosResponse = Message<"journal.api.v1.ListMemosResponse"> & {
  /**
   * The list of memos.
   *
   * @generated from field: repeated journal.api.v1.Memo memos = 1;
   */
  memos: Memo[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   * If this field is omitted, there are no subsequent pages.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemosResponse.
 * Use `create(ListMemosResponseSchema)` to create a new message.
 */
export const ListMemosResponseSchema: GenMessage<ListMemosResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 6);

/**
 * @generated from message journal.api.v1.GetMemoRequest
 */
export type GetMemoRequest = Message<"journal.api.v1.GetMemoRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. Whether to include AI analysis in the response.
   * Default is false.
   *
   * @generated from field: bool include_ai_analysis = 2;
   */
  includeAiAnalysis: boolean;
};

/**
 * Describes the message journal.api.v1.GetMemoRequest.
 * Use `create(GetMemoRequestSchema)` to create a new message.
 */
export const GetMemoRequestSchema: GenMessage<GetMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 7);

/**
 * @generated from message journal.api.v1.UpdateMemoRequest
 */
export type UpdateMemoRequest = Message<"journal.api.v1.UpdateMemoRequest"> & {
  /**
   * Required. The memo to update.
   * The `name` field is required.
   *
   * @generated from field: journal.api.v1.Memo memo = 1;
   */
  memo?: Memo;

  /**
   * Required. The list of fields to update.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateMemoRequest.
 * Use `create(UpdateMemoRequestSchema)` to create a new message.
 */
export const UpdateMemoRequestSchema: GenMessage<UpdateMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 8);

/**
 * @generated from message journal.api.v1.DeleteMemoRequest
 */
export type DeleteMemoRequest = Message<"journal.api.v1.DeleteMemoRequest"> & {
  /**
   * Required. The resource name of the memo to delete.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. If set to true, the memo will be deleted even if it has associated data.
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message journal.api.v1.DeleteMemoRequest.
 * Use `create(DeleteMemoRequestSchema)` to create a new message.
 */
export const DeleteMemoRequestSchema: GenMessage<DeleteMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 9);

/**
 * @generated from message journal.api.v1.SetMemoAttachmentsRequest
 */
export type SetMemoAttachmentsRequest = Message<"journal.api.v1.SetMemoAttachmentsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Required. The attachments to set for the memo.
   *
   * @generated from field: repeated journal.api.v1.Attachment attachments = 2;
   */
  attachments: Attachment[];
};

/**
 * Describes the message journal.api.v1.SetMemoAttachmentsRequest.
 * Use `create(SetMemoAttachmentsRequestSchema)` to create a new message.
 */
export const SetMemoAttachmentsRequestSchema: GenMessage<SetMemoAttachmentsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 10);

/**
 * @generated from message journal.api.v1.ListMemoAttachmentsRequest
 */
export type ListMemoAttachmentsRequest = Message<"journal.api.v1.ListMemoAttachmentsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. The maximum number of attachments to return.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optional. A page token for pagination.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoAttachmentsRequest.
 * Use `create(ListMemoAttachmentsRequestSchema)` to create a new message.
 */
export const ListMemoAttachmentsRequestSchema: GenMessage<ListMemoAttachmentsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 11);

/**
 * @generated from message journal.api.v1.ListMemoAttachmentsResponse
 */
export type ListMemoAttachmentsResponse = Message<"journal.api.v1.ListMemoAttachmentsResponse"> & {
  /**
   * The list of attachments.
   *
   * @generated from field: repeated journal.api.v1.Attachment attachments = 1;
   */
  attachments: Attachment[];

  /**
   * A token for the next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoAttachmentsResponse.
 * Use `create(ListMemoAttachmentsResponseSchema)` to create a new message.
 */
export const ListMemoAttachmentsResponseSchema: GenMessage<ListMemoAttachmentsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 12);

/**
 * @generated from message journal.api.v1.MemoRelation
 */
export type MemoRelation = Message<"journal.api.v1.MemoRelation"> & {
  /**
   * The memo in the relation.
   *
   * @generated from field: journal.api.v1.MemoRelation.Memo memo = 1;
   */
  memo?: MemoRelation_Memo;

  /**
   * The related memo.
   *
   * @generated from field: journal.api.v1.MemoRelation.Memo related_memo = 2;
   */
  relatedMemo?: MemoRelation_Memo;

  /**
   * @generated from field: journal.api.v1.MemoRelation.Type type = 3;
   */
  type: MemoRelation_Type;
};

/**
 * Describes the message journal.api.v1.MemoRelation.
 * Use `create(MemoRelationSchema)` to create a new message.
 */
export const MemoRelationSchema: GenMessage<MemoRelation> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 13);

/**
 * Memo reference in relations.
 *
 * @generated from message journal.api.v1.MemoRelation.Memo
 */
export type MemoRelation_Memo = Message<"journal.api.v1.MemoRelation.Memo"> & {
  /**
   * The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Output only. The snippet of the memo content. Plain text only.
   *
   * @generated from field: string snippet = 2;
   */
  snippet: string;
};

/**
 * Describes the message journal.api.v1.MemoRelation.Memo.
 * Use `create(MemoRelation_MemoSchema)` to create a new message.
 */
export const MemoRelation_MemoSchema: GenMessage<MemoRelation_Memo> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 13, 0);

/**
 * The type of the relation.
 *
 * @generated from enum journal.api.v1.MemoRelation.Type
 */
export enum MemoRelation_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REFERENCE = 1;
   */
  REFERENCE = 1,

  /**
   * @generated from enum value: COMMENT = 2;
   */
  COMMENT = 2,
}

/**
 * Describes the enum journal.api.v1.MemoRelation.Type.
 */
export const MemoRelation_TypeSchema: GenEnum<MemoRelation_Type> = /*@__PURE__*/
  enumDesc(file_api_v1_memo_service, 13, 0);

/**
 * @generated from message journal.api.v1.SetMemoRelationsRequest
 */
export type SetMemoRelationsRequest = Message<"journal.api.v1.SetMemoRelationsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Required. The relations to set for the memo.
   *
   * @generated from field: repeated journal.api.v1.MemoRelation relations = 2;
   */
  relations: MemoRelation[];
};

/**
 * Describes the message journal.api.v1.SetMemoRelationsRequest.
 * Use `create(SetMemoRelationsRequestSchema)` to create a new message.
 */
export const SetMemoRelationsRequestSchema: GenMessage<SetMemoRelationsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 14);

/**
 * @generated from message journal.api.v1.ListMemoRelationsRequest
 */
export type ListMemoRelationsRequest = Message<"journal.api.v1.ListMemoRelationsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. The maximum number of relations to return.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optional. A page token for pagination.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoRelationsRequest.
 * Use `create(ListMemoRelationsRequestSchema)` to create a new message.
 */
export const ListMemoRelationsRequestSchema: GenMessage<ListMemoRelationsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 15);

/**
 * @generated from message journal.api.v1.ListMemoRelationsResponse
 */
export type ListMemoRelationsResponse = Message<"journal.api.v1.ListMemoRelationsResponse"> & {
  /**
   * The list of relations.
   *
   * @generated from field: repeated journal.api.v1.MemoRelation relations = 1;
   */
  relations: MemoRelation[];

  /**
   * A token for the next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoRelationsResponse.
 * Use `create(ListMemoRelationsResponseSchema)` to create a new message.
 */
export const ListMemoRelationsResponseSchema: GenMessage<ListMemoRelationsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 16);

/**
 * @generated from message journal.api.v1.ListMemoReactionsRequest
 */
export type ListMemoReactionsRequest = Message<"journal.api.v1.ListMemoReactionsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. The maximum number of reactions to return.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optional. A page token for pagination.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoReactionsRequest.
 * Use `create(ListMemoReactionsRequestSchema)` to create a new message.
 */
export const ListMemoReactionsRequestSchema: GenMessage<ListMemoReactionsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 17);

/**
 * @generated from message journal.api.v1.ListMemoReactionsResponse
 */
export type ListMemoReactionsResponse = Message<"journal.api.v1.ListMemoReactionsResponse"> & {
  /**
   * The list of reactions.
   *
   * @generated from field: repeated journal.api.v1.Reaction reactions = 1;
   */
  reactions: Reaction[];

  /**
   * A token for the next page of results.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * The total count of reactions.
   *
   * @generated from field: int32 total_size = 3;
   */
  totalSize: number;
};

/**
 * Describes the message journal.api.v1.ListMemoReactionsResponse.
 * Use `create(ListMemoReactionsResponseSchema)` to create a new message.
 */
export const ListMemoReactionsResponseSchema: GenMessage<ListMemoReactionsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 18);

/**
 * @generated from message journal.api.v1.UpsertMemoReactionRequest
 */
export type UpsertMemoReactionRequest = Message<"journal.api.v1.UpsertMemoReactionRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Required. The reaction to upsert.
   *
   * @generated from field: journal.api.v1.Reaction reaction = 2;
   */
  reaction?: Reaction;
};

/**
 * Describes the message journal.api.v1.UpsertMemoReactionRequest.
 * Use `create(UpsertMemoReactionRequestSchema)` to create a new message.
 */
export const UpsertMemoReactionRequestSchema: GenMessage<UpsertMemoReactionRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 19);

/**
 * @generated from message journal.api.v1.DeleteMemoReactionRequest
 */
export type DeleteMemoReactionRequest = Message<"journal.api.v1.DeleteMemoReactionRequest"> & {
  /**
   * Required. The resource name of the reaction to delete.
   * Format: memos/{memo}/reactions/{reaction}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteMemoReactionRequest.
 * Use `create(DeleteMemoReactionRequestSchema)` to create a new message.
 */
export const DeleteMemoReactionRequestSchema: GenMessage<DeleteMemoReactionRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 20);

/**
 * MemoVersion represents a version of a memo.
 *
 * @generated from message journal.api.v1.MemoVersion
 */
export type MemoVersion = Message<"journal.api.v1.MemoVersion"> & {
  /**
   * The version number.
   *
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string memo_name = 2;
   */
  memoName: string;

  /**
   * The Content Schema JSON content of this version.
   *
   * @generated from field: string content_json = 3;
   */
  contentJson: string;

  /**
   * The creation timestamp of this version.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * The creator of this version.
   * Format: users/{user}
   *
   * @generated from field: string creator = 5;
   */
  creator: string;
};

/**
 * Describes the message journal.api.v1.MemoVersion.
 * Use `create(MemoVersionSchema)` to create a new message.
 */
export const MemoVersionSchema: GenMessage<MemoVersion> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 21);

/**
 * @generated from message journal.api.v1.GetMemoVersionRequest
 */
export type GetMemoVersionRequest = Message<"journal.api.v1.GetMemoVersionRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Required. The version number.
   *
   * @generated from field: int32 version = 2;
   */
  version: number;
};

/**
 * Describes the message journal.api.v1.GetMemoVersionRequest.
 * Use `create(GetMemoVersionRequestSchema)` to create a new message.
 */
export const GetMemoVersionRequestSchema: GenMessage<GetMemoVersionRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 22);

/**
 * @generated from message journal.api.v1.ListMemoVersionsRequest
 */
export type ListMemoVersionsRequest = Message<"journal.api.v1.ListMemoVersionsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional. The maximum number of versions to return.
   * The service may return fewer than this value.
   * If unspecified, at most 50 versions will be returned.
   * The maximum value is 1000; values above 1000 will be coerced to 1000.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `ListMemoVersions` call.
   * Provide this to retrieve the subsequent page.
   *
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoVersionsRequest.
 * Use `create(ListMemoVersionsRequestSchema)` to create a new message.
 */
export const ListMemoVersionsRequestSchema: GenMessage<ListMemoVersionsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 23);

/**
 * @generated from message journal.api.v1.ListMemoVersionsResponse
 */
export type ListMemoVersionsResponse = Message<"journal.api.v1.ListMemoVersionsResponse"> & {
  /**
   * The list of memo versions.
   *
   * @generated from field: repeated journal.api.v1.MemoVersion versions = 1;
   */
  versions: MemoVersion[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   * If this field is omitted, there are no subsequent pages.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListMemoVersionsResponse.
 * Use `create(ListMemoVersionsResponseSchema)` to create a new message.
 */
export const ListMemoVersionsResponseSchema: GenMessage<ListMemoVersionsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 24);

/**
 * @generated from message journal.api.v1.DiffMemoVersionsRequest
 */
export type DiffMemoVersionsRequest = Message<"journal.api.v1.DiffMemoVersionsRequest"> & {
  /**
   * Required. The resource name of the memo.
   * Format: memos/{memo}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Required. The first version number to compare.
   *
   * @generated from field: int32 version1 = 2;
   */
  version1: number;

  /**
   * Required. The second version number to compare.
   *
   * @generated from field: int32 version2 = 3;
   */
  version2: number;

  /**
   * Optional. The format of the diff.
   * Supported values: "text", "json". Default is "text".
   *
   * @generated from field: string format = 4;
   */
  format: string;
};

/**
 * Describes the message journal.api.v1.DiffMemoVersionsRequest.
 * Use `create(DiffMemoVersionsRequestSchema)` to create a new message.
 */
export const DiffMemoVersionsRequestSchema: GenMessage<DiffMemoVersionsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 25);

/**
 * @generated from message journal.api.v1.DiffMemoVersionsResponse
 */
export type DiffMemoVersionsResponse = Message<"journal.api.v1.DiffMemoVersionsResponse"> & {
  /**
   * The first version.
   *
   * @generated from field: journal.api.v1.MemoVersion version1 = 1;
   */
  version1?: MemoVersion;

  /**
   * The second version.
   *
   * @generated from field: journal.api.v1.MemoVersion version2 = 2;
   */
  version2?: MemoVersion;

  /**
   * The diff between the two versions.
   * The format depends on the requested format in the request.
   *
   * @generated from field: string diff = 3;
   */
  diff: string;
};

/**
 * Describes the message journal.api.v1.DiffMemoVersionsResponse.
 * Use `create(DiffMemoVersionsResponseSchema)` to create a new message.
 */
export const DiffMemoVersionsResponseSchema: GenMessage<DiffMemoVersionsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 26);

/**
 * SelfContract represents a self-contract investment commitment
 *
 * @generated from message journal.api.v1.SelfContract
 */
export type SelfContract = Message<"journal.api.v1.SelfContract"> & {
  /**
   * The resource name of the self-contract.
   * Format: memos/{memo}/self-contracts/{contract_id}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The memo UID that contains this self-contract.
   *
   * @generated from field: string memo_uid = 2;
   */
  memoUid: string;

  /**
   * The memo ID that contains this self-contract.
   *
   * @generated from field: string memo_id = 3;
   */
  memoId: string;

  /**
   * The unique identifier for this contract within the memo.
   *
   * @generated from field: string contract_id = 4;
   */
  contractId: string;

  /**
   * Stock ticker symbol (e.g., "NVDA", "AAPL")
   *
   * @generated from field: string ticker = 5;
   */
  ticker: string;

  /**
   * Contract template type
   *
   * "value-oriented" or "trading-oriented"
   *
   * @generated from field: string template = 6;
   */
  template: string;

  /**
   * The core investment idea/thesis
   *
   * @generated from field: string idea = 7;
   */
  idea: string;

  /**
   * Expiration date (ISO 8601 format: YYYY-MM-DD)
   *
   * @generated from field: string expiration = 8;
   */
  expiration: string;

  /**
   * Trigger conditions
   *
   * @generated from field: journal.api.v1.Trigger trigger = 9;
   */
  trigger?: Trigger;

  /**
   * Action to take when trigger condition is met
   *
   * @generated from field: string action = 10;
   */
  action: string;

  /**
   * Current status of the contract
   *
   * "active", "triggered", "cancelled", "expired"
   *
   * @generated from field: string status = 11;
   */
  status: string;

  /**
   * When the contract was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * When the contract was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message journal.api.v1.SelfContract.
 * Use `create(SelfContractSchema)` to create a new message.
 */
export const SelfContractSchema: GenMessage<SelfContract> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 27);

/**
 * Trigger represents trigger conditions for a self-contract
 *
 * @generated from message journal.api.v1.Trigger
 */
export type Trigger = Message<"journal.api.v1.Trigger"> & {
  /**
   * Type of trigger
   *
   * "price", "expiration", "time", "custom"
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * Price level for price triggers
   *
   * @generated from field: double price_level = 2;
   */
  priceLevel: number;

  /**
   * Operator for price triggers
   *
   * ">=", "<=", "==", ">", "<"
   *
   * @generated from field: string operator = 3;
   */
  operator: string;

  /**
   * Notes/description of the trigger
   *
   * @generated from field: string notes = 4;
   */
  notes: string;
};

/**
 * Describes the message journal.api.v1.Trigger.
 * Use `create(TriggerSchema)` to create a new message.
 */
export const TriggerSchema: GenMessage<Trigger> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 28);

/**
 * GetSelfContractsRequest is the request message for GetSelfContracts
 *
 * @generated from message journal.api.v1.GetSelfContractsRequest
 */
export type GetSelfContractsRequest = Message<"journal.api.v1.GetSelfContractsRequest"> & {
  /**
   * Optional. Filter by ticker symbol
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * Optional. Filter by status
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * Optional. Filter by template type
   *
   * @generated from field: string template = 3;
   */
  template: string;

  /**
   * Optional. The maximum number of contracts to return.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `GetSelfContracts` call.
   *
   * @generated from field: string page_token = 5;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.GetSelfContractsRequest.
 * Use `create(GetSelfContractsRequestSchema)` to create a new message.
 */
export const GetSelfContractsRequestSchema: GenMessage<GetSelfContractsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 29);

/**
 * GetSelfContractsResponse is the response message for GetSelfContracts
 *
 * @generated from message journal.api.v1.GetSelfContractsResponse
 */
export type GetSelfContractsResponse = Message<"journal.api.v1.GetSelfContractsResponse"> & {
  /**
   * The list of self-contracts
   *
   * @generated from field: repeated journal.api.v1.SelfContract contracts = 1;
   */
  contracts: SelfContract[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total count of self-contracts matching the filter
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message journal.api.v1.GetSelfContractsResponse.
 * Use `create(GetSelfContractsResponseSchema)` to create a new message.
 */
export const GetSelfContractsResponseSchema: GenMessage<GetSelfContractsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 30);

/**
 * Decision represents a post-trade decision
 *
 * @generated from message journal.api.v1.Decision
 */
export type Decision = Message<"journal.api.v1.Decision"> & {
  /**
   * The resource name of the decision.
   * Format: memos/{memo}/decisions/{decision_id}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The memo UID that contains this decision.
   *
   * @generated from field: string memo_uid = 2;
   */
  memoUid: string;

  /**
   * The memo ID that contains this decision.
   *
   * @generated from field: string memo_id = 3;
   */
  memoId: string;

  /**
   * Stock symbol (e.g., "NVDA")
   *
   * @generated from field: string ticker = 4;
   */
  ticker: string;

  /**
   * Reference to Self-Contract ID (optional)
   *
   * @generated from field: string contract_uid = 5;
   */
  contractUid: string;

  /**
   * Decision type: BUY | SELL | HOLD
   *
   * @generated from field: string decision = 6;
   */
  decision: string;

  /**
   * Action type: FOLLOW | OVERRIDE
   *
   * @generated from field: string action_type = 7;
   */
  actionType: string;

  /**
   * Execution price
   *
   * @generated from field: double price = 8;
   */
  price: number;

  /**
   * Number of shares
   *
   * @generated from field: double quantity = 9;
   */
  quantity: number;

  /**
   * Decision rationale
   *
   * @generated from field: string reason = 10;
   */
  reason: string;

  /**
   * ISO 8601 timestamp when the decision was executed
   *
   * @generated from field: google.protobuf.Timestamp executed_at = 11;
   */
  executedAt?: Timestamp;

  /**
   * ISO 8601 timestamp when the decision was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message journal.api.v1.Decision.
 * Use `create(DecisionSchema)` to create a new message.
 */
export const DecisionSchema: GenMessage<Decision> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 31);

/**
 * GetDecisionsRequest is the request message for GetDecisions
 *
 * @generated from message journal.api.v1.GetDecisionsRequest
 */
export type GetDecisionsRequest = Message<"journal.api.v1.GetDecisionsRequest"> & {
  /**
   * Optional. Filter by ticker symbol
   *
   * @generated from field: string ticker = 1;
   */
  ticker: string;

  /**
   * Optional. Filter by contract UID
   *
   * @generated from field: string contract_uid = 2;
   */
  contractUid: string;

  /**
   * Optional. Filter by decision type (BUY, SELL, HOLD)
   *
   * @generated from field: string decision = 3;
   */
  decision: string;

  /**
   * Optional. Filter by action type (FOLLOW, OVERRIDE)
   *
   * @generated from field: string action_type = 4;
   */
  actionType: string;

  /**
   * Optional. Filter by start time (unix timestamp in seconds)
   *
   * @generated from field: int64 from_ts = 5;
   */
  fromTs: bigint;

  /**
   * Optional. Filter by end time (unix timestamp in seconds)
   *
   * @generated from field: int64 to_ts = 6;
   */
  toTs: bigint;

  /**
   * Optional. The maximum number of decisions to return.
   *
   * @generated from field: int32 page_size = 7;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `GetDecisions` call.
   *
   * @generated from field: string page_token = 8;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.GetDecisionsRequest.
 * Use `create(GetDecisionsRequestSchema)` to create a new message.
 */
export const GetDecisionsRequestSchema: GenMessage<GetDecisionsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 32);

/**
 * GetDecisionsResponse is the response message for GetDecisions
 *
 * @generated from message journal.api.v1.GetDecisionsResponse
 */
export type GetDecisionsResponse = Message<"journal.api.v1.GetDecisionsResponse"> & {
  /**
   * The list of decisions
   *
   * @generated from field: repeated journal.api.v1.Decision decisions = 1;
   */
  decisions: Decision[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total count of decisions matching the filter
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message journal.api.v1.GetDecisionsResponse.
 * Use `create(GetDecisionsResponseSchema)` to create a new message.
 */
export const GetDecisionsResponseSchema: GenMessage<GetDecisionsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 33);

/**
 * GetActionsRequest is the request message for GetActions
 *
 * @generated from message journal.api.v1.GetActionsRequest
 */
export type GetActionsRequest = Message<"journal.api.v1.GetActionsRequest"> & {
  /**
   * Optional. Filter by action type (e.g., "self-contract", "decision")
   * If empty, returns all action-type memos.
   *
   * @generated from field: string action_type = 1;
   */
  actionType: string;

  /**
   * Optional. Filter by ticker symbol
   *
   * @generated from field: string ticker = 2;
   */
  ticker: string;

  /**
   * Optional. Filter by memo status (NORMAL, ARCHIVED)
   *
   * @generated from field: string state = 3;
   */
  state: string;

  /**
   * Optional. The maximum number of memos to return.
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * Optional. A page token, received from a previous `GetActions` call.
   *
   * @generated from field: string page_token = 5;
   */
  pageToken: string;
};

/**
 * Describes the message journal.api.v1.GetActionsRequest.
 * Use `create(GetActionsRequestSchema)` to create a new message.
 */
export const GetActionsRequestSchema: GenMessage<GetActionsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 34);

/**
 * GetActionsResponse is the response message for GetActions
 *
 * @generated from message journal.api.v1.GetActionsResponse
 */
export type GetActionsResponse = Message<"journal.api.v1.GetActionsResponse"> & {
  /**
   * The list of action-type memos
   *
   * @generated from field: repeated journal.api.v1.Memo memos = 1;
   */
  memos: Memo[];

  /**
   * A token that can be sent as `page_token` to retrieve the next page.
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * Total count of action-type memos matching the filter
   *
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message journal.api.v1.GetActionsResponse.
 * Use `create(GetActionsResponseSchema)` to create a new message.
 */
export const GetActionsResponseSchema: GenMessage<GetActionsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 35);

/**
 * UITreeFragment represents a fragment of the UI tree streaming response.
 *
 * @generated from message journal.api.v1.UITreeFragment
 */
export type UITreeFragment = Message<"journal.api.v1.UITreeFragment"> & {
  /**
   * Control event type (e.g., "memo.saved", "stream.end", "ai.error").
   *
   * @generated from field: string control = 1;
   */
  control: string;

  /**
   * Data payload for this fragment.
   *
   * @generated from oneof journal.api.v1.UITreeFragment.data
   */
  data: {
    /**
     * MemoSavedEvent contains memo_id after memo is saved.
     *
     * @generated from field: journal.api.v1.MemoSavedEvent memo_saved = 2;
     */
    value: MemoSavedEvent;
    case: "memoSaved";
  } | {
    /**
     * UITreeUpdate contains the UI tree structure.
     *
     * @generated from field: journal.api.v1.UITreeUpdate tree = 3;
     */
    value: UITreeUpdate;
    case: "tree";
  } | {
    /**
     * AIError contains error details if AI analysis fails.
     *
     * @generated from field: journal.api.v1.AIErrorEvent error = 4;
     */
    value: AIErrorEvent;
    case: "error";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message journal.api.v1.UITreeFragment.
 * Use `create(UITreeFragmentSchema)` to create a new message.
 */
export const UITreeFragmentSchema: GenMessage<UITreeFragment> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 36);

/**
 * MemoSavedEvent is sent when memo is successfully saved.
 *
 * @generated from message journal.api.v1.MemoSavedEvent
 */
export type MemoSavedEvent = Message<"journal.api.v1.MemoSavedEvent"> & {
  /**
   * The resource name of the saved memo.
   * Format: memos/{memo}
   *
   * @generated from field: string memo_name = 1;
   */
  memoName: string;

  /**
   * The memo UID.
   *
   * @generated from field: string memo_uid = 2;
   */
  memoUid: string;
};

/**
 * Describes the message journal.api.v1.MemoSavedEvent.
 * Use `create(MemoSavedEventSchema)` to create a new message.
 */
export const MemoSavedEventSchema: GenMessage<MemoSavedEvent> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 37);

/**
 * UITreeUpdate contains the UI tree structure for rendering.
 *
 * @generated from message journal.api.v1.UITreeUpdate
 */
export type UITreeUpdate = Message<"journal.api.v1.UITreeUpdate"> & {
  /**
   * The root element key.
   *
   * @generated from field: string root = 1;
   */
  root: string;

  /**
   * Map of element key to element data.
   *
   * @generated from field: map<string, journal.api.v1.UIElement> elements = 2;
   */
  elements: { [key: string]: UIElement };
};

/**
 * Describes the message journal.api.v1.UITreeUpdate.
 * Use `create(UITreeUpdateSchema)` to create a new message.
 */
export const UITreeUpdateSchema: GenMessage<UITreeUpdate> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 38);

/**
 * UIElement represents a single UI element in the tree.
 *
 * @generated from message journal.api.v1.UIElement
 */
export type UIElement = Message<"journal.api.v1.UIElement"> & {
  /**
   * Element key (unique within the tree).
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Element type (e.g., "Container", "TextBlock", "MetricCard", "DataTable", "ListBlock", "CodeBlock").
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * Element properties (component-specific props).
   *
   * @generated from field: google.protobuf.Struct props = 3;
   */
  props?: JsonObject;

  /**
   * Child element keys (for container elements).
   *
   * @generated from field: repeated string children = 4;
   */
  children: string[];
};

/**
 * Describes the message journal.api.v1.UIElement.
 * Use `create(UIElementSchema)` to create a new message.
 */
export const UIElementSchema: GenMessage<UIElement> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 39);

/**
 * AIErrorEvent contains error details when AI analysis fails.
 *
 * @generated from message journal.api.v1.AIErrorEvent
 */
export type AIErrorEvent = Message<"journal.api.v1.AIErrorEvent"> & {
  /**
   * Error message.
   *
   * @generated from field: string message = 1;
   */
  message: string;

  /**
   * Error code (optional).
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message journal.api.v1.AIErrorEvent.
 * Use `create(AIErrorEventSchema)` to create a new message.
 */
export const AIErrorEventSchema: GenMessage<AIErrorEvent> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 40);

/**
 * CreateMemoWithAIRequest is the request message for CreateMemoWithAI.
 *
 * @generated from message journal.api.v1.CreateMemoWithAIRequest
 */
export type CreateMemoWithAIRequest = Message<"journal.api.v1.CreateMemoWithAIRequest"> & {
  /**
   * Required. The memo to create.
   *
   * @generated from field: journal.api.v1.Memo memo = 1;
   */
  memo?: Memo;

  /**
   * Optional. The memo ID to use for this memo.
   * If empty, a unique ID will be generated.
   *
   * @generated from field: string memo_id = 2;
   */
  memoId: string;

  /**
   * Optional. Whether to enable AI analysis.
   * Default is true.
   *
   * @generated from field: bool enable_ai = 3;
   */
  enableAi: boolean;
};

/**
 * Describes the message journal.api.v1.CreateMemoWithAIRequest.
 * Use `create(CreateMemoWithAIRequestSchema)` to create a new message.
 */
export const CreateMemoWithAIRequestSchema: GenMessage<CreateMemoWithAIRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 41);

/**
 * CreateMemoWithAIResponse is the response message for CreateMemoWithAI (streaming).
 *
 * @generated from message journal.api.v1.CreateMemoWithAIResponse
 */
export type CreateMemoWithAIResponse = Message<"journal.api.v1.CreateMemoWithAIResponse"> & {
  /**
   * The UI tree fragment.
   *
   * @generated from field: journal.api.v1.UITreeFragment fragment = 1;
   */
  fragment?: UITreeFragment;
};

/**
 * Describes the message journal.api.v1.CreateMemoWithAIResponse.
 * Use `create(CreateMemoWithAIResponseSchema)` to create a new message.
 */
export const CreateMemoWithAIResponseSchema: GenMessage<CreateMemoWithAIResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 42);

/**
 * UpdateMemoWithAIRequest is the request message for UpdateMemoWithAI.
 *
 * @generated from message journal.api.v1.UpdateMemoWithAIRequest
 */
export type UpdateMemoWithAIRequest = Message<"journal.api.v1.UpdateMemoWithAIRequest"> & {
  /**
   * Required. The resource name of the memo to update.
   * Format: memos/{memo}
   *
   * @generated from field: string memo_name = 1;
   */
  memoName: string;

  /**
   * Optional. Whether to update the memo content before re-analysis.
   * If provided, the memo will be updated with this content first.
   *
   * @generated from field: string updated_content = 2;
   */
  updatedContent: string;

  /**
   * Optional. Whether to enable AI analysis.
   * Default is true.
   *
   * @generated from field: bool enable_ai = 3;
   */
  enableAi: boolean;
};

/**
 * Describes the message journal.api.v1.UpdateMemoWithAIRequest.
 * Use `create(UpdateMemoWithAIRequestSchema)` to create a new message.
 */
export const UpdateMemoWithAIRequestSchema: GenMessage<UpdateMemoWithAIRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 43);

/**
 * BatchGetMemosByUIDsRequest is the request message for BatchGetMemosByUIDs.
 *
 * @generated from message journal.api.v1.BatchGetMemosByUIDsRequest
 */
export type BatchGetMemosByUIDsRequest = Message<"journal.api.v1.BatchGetMemosByUIDsRequest"> & {
  /**
   * Required. The list of memo UIDs to fetch.
   *
   * @generated from field: repeated string uids = 1;
   */
  uids: string[];
};

/**
 * Describes the message journal.api.v1.BatchGetMemosByUIDsRequest.
 * Use `create(BatchGetMemosByUIDsRequestSchema)` to create a new message.
 */
export const BatchGetMemosByUIDsRequestSchema: GenMessage<BatchGetMemosByUIDsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 44);

/**
 * BatchGetMemosByUIDsResponse is the response message for BatchGetMemosByUIDs.
 *
 * @generated from message journal.api.v1.BatchGetMemosByUIDsResponse
 */
export type BatchGetMemosByUIDsResponse = Message<"journal.api.v1.BatchGetMemosByUIDsResponse"> & {
  /**
   * Map of UID -> memo. Not found UIDs will be omitted from the map.
   *
   * @generated from field: map<string, journal.api.v1.Memo> memos = 1;
   */
  memos: { [key: string]: Memo };
};

/**
 * Describes the message journal.api.v1.BatchGetMemosByUIDsResponse.
 * Use `create(BatchGetMemosByUIDsResponseSchema)` to create a new message.
 */
export const BatchGetMemosByUIDsResponseSchema: GenMessage<BatchGetMemosByUIDsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 45);

/**
 * ListActivityStatsRequest is the request message for ListActivityStats.
 *
 * @generated from message journal.api.v1.ListActivityStatsRequest
 */
export type ListActivityStatsRequest = Message<"journal.api.v1.ListActivityStatsRequest"> & {
  /**
   * Required. The parent resource name.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Required. Start date in YYYYMMDD format (e.g., 20260301).
   *
   * @generated from field: int64 start_date = 2;
   */
  startDate: bigint;

  /**
   * Required. End date in YYYYMMDD format (e.g., 20260430).
   *
   * @generated from field: int64 end_date = 3;
   */
  endDate: bigint;

  /**
   * Optional. Timezone for date grouping in calendar heatmap (e.g., "Asia/Shanghai", "UTC").
   * DEPRECATED (v0.65.0): Backend auto-detects timezone from user_setting table.
   * This field is ignored and will be removed in v0.66.0.
   * If not specified, defaults to "Asia/Shanghai" (China Standard Time).
   * This ensures memos created at early hours (e.g., 1:00 AM CST) appear on the correct day in calendar.
   * Uses IANA timezone database names (https://en.wikipedia.org/wiki/List_of_tz_database_time_zones).
   *
   * @generated from field: string timezone = 4 [deprecated = true];
   * @deprecated
   */
  timezone: string;
};

/**
 * Describes the message journal.api.v1.ListActivityStatsRequest.
 * Use `create(ListActivityStatsRequestSchema)` to create a new message.
 */
export const ListActivityStatsRequestSchema: GenMessage<ListActivityStatsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 46);

/**
 * HolidayInfo represents a market holiday with trading hours information.
 *
 * @generated from message journal.api.v1.HolidayInfo
 */
export type HolidayInfo = Message<"journal.api.v1.HolidayInfo"> & {
  /**
   * Date in YYYY-MM-DD format.
   *
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * Holiday name (e.g., "Thanksgiving Day").
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Trading hours for regular session in US Eastern Time.
   * Examples:
   *   - "09:30-16:00" = Regular trading hours
   *   - "09:30-13:00" = Early close (Thanksgiving Day)
   *   - "" = Market closed for the entire day
   *
   * @generated from field: string trading_hour = 3;
   */
  tradingHour: string;

  /**
   * Trading hours for post-market session in US Eastern Time.
   * Examples:
   *   - "16:00-17:00" = Regular post-market
   *   - "13:00-17:00" = Extended post-market (early close days)
   *   - "" = No post-market trading
   *
   * @generated from field: string post_market = 4;
   */
  postMarket: string;
};

/**
 * Describes the message journal.api.v1.HolidayInfo.
 * Use `create(HolidayInfoSchema)` to create a new message.
 */
export const HolidayInfoSchema: GenMessage<HolidayInfo> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 47);

/**
 * ListActivityStatsResponse is the response message for ListActivityStats.
 *
 * @generated from message journal.api.v1.ListActivityStatsResponse
 */
export type ListActivityStatsResponse = Message<"journal.api.v1.ListActivityStatsResponse"> & {
  /**
   * Activity statistics mapping date (YYYY-MM-DD) to memo count.
   * Example: {"2026-03-01": 6, "2026-03-02": 3}
   *
   * @generated from field: map<string, int32> activity_stats = 1;
   */
  activityStats: { [key: string]: number };

  /**
   * Holidays mapping date (YYYY-MM-DD) to holiday info.
   * Example: {"2026-01-01": {date: "2026-01-01", name: "New Year's Day", trading_hour: "", post_market: ""}}
   *
   * @generated from field: map<string, journal.api.v1.HolidayInfo> holidays = 2;
   */
  holidays: { [key: string]: HolidayInfo };
};

/**
 * Describes the message journal.api.v1.ListActivityStatsResponse.
 * Use `create(ListActivityStatsResponseSchema)` to create a new message.
 */
export const ListActivityStatsResponseSchema: GenMessage<ListActivityStatsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_memo_service, 48);

/**
 * @generated from service journal.api.v1.JournalService
 */
export const JournalService: GenService<{
  /**
   * CreateMemo creates a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.CreateMemo
   */
  createMemo: {
    methodKind: "unary";
    input: typeof CreateMemoRequestSchema;
    output: typeof MemoSchema;
  },
  /**
   * ListMemos lists memos with pagination and filter.
   *
   * @generated from rpc journal.api.v1.JournalService.ListMemos
   */
  listMemos: {
    methodKind: "unary";
    input: typeof ListMemosRequestSchema;
    output: typeof ListMemosResponseSchema;
  },
  /**
   * GetMemo gets a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.GetMemo
   */
  getMemo: {
    methodKind: "unary";
    input: typeof GetMemoRequestSchema;
    output: typeof MemoSchema;
  },
  /**
   * BatchGetMemosByUIDs batch retrieves memos by their UIDs.
   *
   * @generated from rpc journal.api.v1.JournalService.BatchGetMemosByUIDs
   */
  batchGetMemosByUIDs: {
    methodKind: "unary";
    input: typeof BatchGetMemosByUIDsRequestSchema;
    output: typeof BatchGetMemosByUIDsResponseSchema;
  },
  /**
   * UpdateMemo updates a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.UpdateMemo
   */
  updateMemo: {
    methodKind: "unary";
    input: typeof UpdateMemoRequestSchema;
    output: typeof MemoSchema;
  },
  /**
   * DeleteMemo deletes a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.DeleteMemo
   */
  deleteMemo: {
    methodKind: "unary";
    input: typeof DeleteMemoRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * SetMemoAttachments sets attachments for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.SetMemoAttachments
   */
  setMemoAttachments: {
    methodKind: "unary";
    input: typeof SetMemoAttachmentsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ListMemoAttachments lists attachments for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.ListMemoAttachments
   */
  listMemoAttachments: {
    methodKind: "unary";
    input: typeof ListMemoAttachmentsRequestSchema;
    output: typeof ListMemoAttachmentsResponseSchema;
  },
  /**
   * SetMemoRelations sets relations for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.SetMemoRelations
   */
  setMemoRelations: {
    methodKind: "unary";
    input: typeof SetMemoRelationsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ListMemoRelations lists relations for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.ListMemoRelations
   */
  listMemoRelations: {
    methodKind: "unary";
    input: typeof ListMemoRelationsRequestSchema;
    output: typeof ListMemoRelationsResponseSchema;
  },
  /**
   * ListMemoReactions lists reactions for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.ListMemoReactions
   */
  listMemoReactions: {
    methodKind: "unary";
    input: typeof ListMemoReactionsRequestSchema;
    output: typeof ListMemoReactionsResponseSchema;
  },
  /**
   * UpsertMemoReaction upserts a reaction for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.UpsertMemoReaction
   */
  upsertMemoReaction: {
    methodKind: "unary";
    input: typeof UpsertMemoReactionRequestSchema;
    output: typeof ReactionSchema;
  },
  /**
   * DeleteMemoReaction deletes a reaction for a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.DeleteMemoReaction
   */
  deleteMemoReaction: {
    methodKind: "unary";
    input: typeof DeleteMemoReactionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetMemoVersion gets a specific version of a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.GetMemoVersion
   */
  getMemoVersion: {
    methodKind: "unary";
    input: typeof GetMemoVersionRequestSchema;
    output: typeof MemoVersionSchema;
  },
  /**
   * ListMemoVersions lists all versions of a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.ListMemoVersions
   */
  listMemoVersions: {
    methodKind: "unary";
    input: typeof ListMemoVersionsRequestSchema;
    output: typeof ListMemoVersionsResponseSchema;
  },
  /**
   * DiffMemoVersions diffs two versions of a memo.
   *
   * @generated from rpc journal.api.v1.JournalService.DiffMemoVersions
   */
  diffMemoVersions: {
    methodKind: "unary";
    input: typeof DiffMemoVersionsRequestSchema;
    output: typeof DiffMemoVersionsResponseSchema;
  },
  /**
   * GetSelfContracts gets self-contracts for the current user.
   *
   * @generated from rpc journal.api.v1.JournalService.GetSelfContracts
   */
  getSelfContracts: {
    methodKind: "unary";
    input: typeof GetSelfContractsRequestSchema;
    output: typeof GetSelfContractsResponseSchema;
  },
  /**
   * GetDecisions gets decisions for the current user.
   *
   * @generated from rpc journal.api.v1.JournalService.GetDecisions
   */
  getDecisions: {
    methodKind: "unary";
    input: typeof GetDecisionsRequestSchema;
    output: typeof GetDecisionsResponseSchema;
  },
  /**
   * GetActions gets action-type memos (memos containing action nodes) for the current user.
   *
   * @generated from rpc journal.api.v1.JournalService.GetActions
   */
  getActions: {
    methodKind: "unary";
    input: typeof GetActionsRequestSchema;
    output: typeof GetActionsResponseSchema;
  },
  /**
   * CreateMemoWithAI creates a memo and streams AI analysis results.
   *
   * @generated from rpc journal.api.v1.JournalService.CreateMemoWithAI
   */
  createMemoWithAI: {
    methodKind: "server_streaming";
    input: typeof CreateMemoWithAIRequestSchema;
    output: typeof CreateMemoWithAIResponseSchema;
  },
  /**
   * UpdateMemoWithAI updates a memo's AI analysis by re-triggering analysis.
   * This RPC returns streaming AI analysis results using the same format as CreateMemoWithAI.
   *
   * @generated from rpc journal.api.v1.JournalService.UpdateMemoWithAI
   */
  updateMemoWithAI: {
    methodKind: "server_streaming";
    input: typeof UpdateMemoWithAIRequestSchema;
    output: typeof CreateMemoWithAIResponseSchema;
  },
  /**
   * ListActivityStats lists activity statistics for calendar heatmap visualization.
   * Returns aggregated memo counts by date and holiday information for the specified date range.
   *
   * @generated from rpc journal.api.v1.JournalService.ListActivityStats
   */
  listActivityStats: {
    methodKind: "unary";
    input: typeof ListActivityStatsRequestSchema;
    output: typeof ListActivityStatsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_memo_service, 0);

